export const initialState = {
  userData: {},
  accessToken: '',
  loading: false,
  error: null,
  isLogin: false,
};
